export const RDS_CREATE_USER = "CREATE USER p0_iam_manager;";
export const RDS_GRANT_IAM = "GRANT rds_iam TO p0_iam_manager;";
export const RDS_GRANT_SUPERUSER = "GRANT rds_superuser TO p0_iam_manager;";

/** The SQL that creates the connector's `p0_iam_manager` user on AWS RDS, in the order it must run. */
export const RDS_SETUP_SQL = [
  RDS_CREATE_USER,
  RDS_GRANT_IAM,
  RDS_GRANT_SUPERUSER,
] as const;
